import React from 'react';
import { useTranslation } from 'react-i18next';
import { getStyles } from './styles';
import product1 from '../../assets/images/products/15-48cm.jpg';
import product2 from '../../assets/images/products/5-15cm.jpg';
import product3 from '../../assets/images/products/1-5cm.jpg';
import product4 from '../../assets/images/products/4.jpg';
import product5 from '../../assets/images/products/5.jpg';
import product6 from '../../assets/images/products/6.jpg';
import product7 from '../../assets/images/products/7.jpg';
import product8 from '../../assets/images/products/8.jpg';

import packing1 from '../../assets/images/products/packing1.jpeg';
import packing2 from '../../assets/images/products/packing2.jpeg';
import packing3 from '../../assets/images/products/packing3.jpeg';
import packing4 from '../../assets/images/products/packing4.jpg';
import packing5 from '../../assets/images/products/packing5.jpg';
import packing6 from '../../assets/images/products/packing6.jpg';
import ProductsTree from '../productsTree/ProductsTree';

const Products = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const styles = getStyles(isRtl);

  const products = [
    {
      id: 1,
      image: product1,
      // titleKey: 'aboutUs.products.8',
      descriptionKey: '15CM - 48CM',
      // codeNo: 'R-G-48'
    },
    {
      id: 2,
      image: product2,
      // titleKey: 'aboutUs.products.7',
      descriptionKey: '5CM - 15CM',
      // codeNo: 'R-G-15'
    },
    {
      id: 3,
      image: product3,
      // titleKey: 'aboutUs.products.6',
      descriptionKey: '1CM - 5CM',
      // codeNo: 'R-G-5'
    },
    {
      id: 4,
      image: product4,
      // titleKey: 'aboutUs.products.1',
      descriptionKey: '4000µm - 6000µm',
      // codeNo: 'R-L-48'
    },
    {
      id: 5,
      image: product5,
      // titleKey: 'aboutUs.products.2',
      descriptionKey: '2000µm : 3000µm',
      // codeNo: 'R-L-24'
    },
    {
      id: 6,
      image: product6,
      // titleKey: 'aboutUs.products.3',
      descriptionKey: '1000µm : 2000µm',
      // codeNo: 'R-L-12'
    },
    {
      id: 7,
      image: product7,
      // titleKey: 'aboutUs.products.4',
      descriptionKey: '250µm - 500µm',
      // codeNo: 'R-L-6'
    },
    {
      id: 8,
      image: product8,
      // titleKey: 'aboutUs.products.5',
      descriptionKey: '8µm - 200µm',
      // codeNo: 'R-C-200 TO R-C-08'
    },
  ];

  const packing = [
    {
      id: 1,
      image: packing1,
      description: 'packing (25 kg  bags)',
    },
    {
      id: 2,
      image: packing2,
      description: 'packing (50 kg  bags)',
    },
    {
      id: 3,
      image: packing3,
      description: 'packing (25 kg  bags)',
    },
    {
      id: 4,
      image: packing4,
      description: 'packing (1500 kg  big bags)',
    },
    {
      id: 5,
      image: packing5,
      description: 'packing (50 kg  bags)',
    },
    {
      id: 6,
      image: packing6,
      description: 'Container packing (bulk)',
    },
  ]

  return (
    <div style={styles.productsContainer}>
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>{t('products.title')}</h1>
        {/* <img src={product_bg} alt='product_bg' style={styles.product_bg} /> */}
        <p style={{...styles.headerDescription, color: '#7f6001',}}>{t('products.description')}</p>
      </div>


      <ProductsTree />

      {/* <div style={styles.productsGrid}>
        {products.map((product) => (
          <div
            key={product.id}
            style={styles.productCard}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform =
                styles.productCardHover.transform;
              e.currentTarget.style.boxShadow =
                styles.productCardHover.boxShadow;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'none';
              e.currentTarget.style.boxShadow = styles.productCard.boxShadow;
            }}
          >
            <img
              src={product.image}
              alt={t(product.titleKey)}
              style={styles.productImage}
            />
            <div style={styles.productContent}>
              <h3 style={styles.productTitle}>{t(product.titleKey)}</h3>
              <p style={styles.productDescription}>
                {t(product.descriptionKey)}
              </p>
              <div style={{ width: '100%', textAlign: isRtl ? 'right' : 'left' }}>
                <span style={styles.productCode}>{t('products.code')}: {product.codeNo}</span>
              </div>
            </div>
          </div>
        ))}
      </div> */}

      <div style={styles.header}>
        <h1 style={styles.headerTitle}>{t('ourPacking')}</h1>
        <p style={{color: '#7f6001',}}>
          {t('packingDesc')}
        </p>
      </div>
      <div>

      <div style={styles.productsGrid}>
        {packing.map((item) => (
          <div
            key={item.id}
            style={styles.productCard}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform =
                styles.productCardHover.transform;
              e.currentTarget.style.boxShadow =
                styles.productCardHover.boxShadow;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'none';
              e.currentTarget.style.boxShadow = styles.productCard.boxShadow;
            }}
          >
            <img
              src={item.image}
              alt={t(item.titleKey)}
              style={styles.productImage}
            />
            <div style={styles.productContent}>
              {/* <h3 style={styles.productTitle}>{t(product.titleKey)}</h3> */}
              <p style={{...styles.productDescription, color: '#7f6001',textAlign: 'center'}}>
                {t(item.description)}
              </p>
              {/* <div style={{ width: '100%', textAlign: isRtl ? 'right' : 'left' }}>
                <span style={styles.productCode}>{t('products.code')}: {product.codeNo}</span>
              </div> */}
            </div>
          </div>
        ))}
      </div>

      </div>
    </div>
  );
};

export default Products;
